import PropTypes from 'prop-types';
import React from 'react';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import ErrorBoundary from './ErrorBoundary';
import theme from '../theme';

class AppRoot extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  // Remove the server-side injected CSS.
  componentDidMount() {
    const jssStyles = global.document.getElementById('jss-server-side');

    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <React.StrictMode>
          <MuiThemeProvider theme={theme}>
            {this.props.children}
          </MuiThemeProvider>
        </React.StrictMode>
      </ErrorBoundary>
    );
  }
}

const styles = () => ({
  '@global': {
    body: {
      margin: 0,
    },
  },
});

const AppRootWithStyles = withStyles(styles)(AppRoot);

export default AppRootWithStyles;
